import { render, staticRenderFns } from "./TrasladosTiendasComponent.vue?vue&type=template&id=581b1ca8&"
import script from "./TrasladosTiendasComponent.vue?vue&type=script&lang=js&"
export * from "./TrasladosTiendasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports